export default __webpack_public_path__ + "static/media/Kasala Banner_2020-02.79a3b360.png";